import { AppBar, Container, Toolbar, Box } from "@mui/material";
import React, { useEffect } from "react";
import ReactFlagsSelect from "react-flags-select";
import logo from "../../rgn-logo.svg";
import { useTranslation } from "react-i18next";

export default function Navbar() {
  const [language, setLanguage] = React.useState<string>("US");
  const { i18n } = useTranslation();
  const changeLanguage = (lng: string) => {
    i18n.changeLanguage(lng.toLowerCase() === "us" ? "en" : lng.toLowerCase());
    setLanguage(lng);
  };

  useEffect(() => {
    setLanguage(
      i18n.language.toUpperCase() === "EN" ? "US" : i18n.language.toUpperCase()
    );
  }, []);

  return (
    <AppBar
      position="sticky"
      elevation={0}
      sx={{
        bgcolor: "white",
        color: "inherit",
        borderBottom: "1px solid #ebebeb",
      }}
    >
      <Container maxWidth="xl">
        <Toolbar
          disableGutters
          sx={{ justifyContent: "space-between", height: 80 }}
        >
          <img src={logo} width={150} />
          <Box sx={{ flexGrow: 0 }}>
            <ReactFlagsSelect
              className="language-selector"
              countries={["US", "RU", "UZ"]}
              customLabels={{
                US: "English",
                RU: "Русский",
                UZ: "Uzbek",
              }}
              placeholder="Tilni tanlang"
              onSelect={(code) => changeLanguage(code)}
              selected={language}
            />
          </Box>
        </Toolbar>
      </Container>
    </AppBar>
  );
}
